import { ICrudGenericFields } from 'models/CrudInterface'

export const companyDataFields: Array<ICrudGenericFields> = [
	{
		id: 'niparam',
		type: 'text',
		labelWidth: 'col-sm-2',
		width: 'col-sm-1',
		height: 'col-sm-12',
		default: null,
		maxChars: 20,
		autoComplete: 'new-off',
		disabled: false,
		comboData: '',
		dependsOn: {
			id: '',
			values: [
				{
					idValue: '',
					disabled: false
				}
			]
		}
	},
	{
		id: 'descrip',
		type: 'text',
		labelWidth: 'col-sm-2',
		width: 'col-sm-3',
		height: 'col-sm-12',
		default: null,
		maxChars: 30,
		autoComplete: 'new-off',
		disabled: false,
		comboData: '',
		dependsOn: {
			id: '',
			values: [
				{
					idValue: '',
					disabled: false
				}
			]
		}
	},
	{
		id: 'modulo',
		type: 'text',
		labelWidth: 'col-sm-2',
		width: 'col-sm-1',
		height: 'col-sm-12',
		default: null,
		maxChars: 1,
		autoComplete: 'new-off',
		disabled: false,
		comboData: '',
		dependsOn: {
			id: '',
			values: [
				{
					idValue: '',
					disabled: false
				}
			]
		}
	},
	{
		id: 'tipo_dato',
		type: 'text',
		labelWidth: 'col-sm-2',
		width: 'col-sm-2',
		height: 'col-sm-12',
		default: null,
		maxChars: 10,
		autoComplete: 'new-off',
		disabled: false,
		comboData: '',
		dependsOn: {
			id: '',
			values: [
				{
					idValue: '',
					disabled: false
				}
			]
		}
	},
	{
		id: 'tipo_campo',
		type: 'combo',
		labelWidth: 'col-sm-2',
		width: 'col-sm-2',
		height: 'col-sm-12',
		default: null,
		maxChars: 1,
		autoComplete: 'new-off',
		disabled: false,
		comboData: 'dataType',
		dependsOn: {
			id: '',
			values: [
				{
					idValue: '',
					disabled: false
				}
			]
		}
	},
	{
		id: 'modif',
		type: 'check',
		labelWidth: 'col-sm-2',
		width: 'col-sm-1',
		height: 'col-sm-12',
		default: null,
		maxChars: 1,
		autoComplete: 'new-off',
		disabled: false,
		comboData: '',
		dependsOn: {
			id: '',
			values: [
				{
					idValue: '',
					disabled: false
				}
			]
		}
	},
	{
		id: 'valnum1',
		type: 'text',
		labelWidth: 'col-sm-2',
		width: 'col-sm-2',
		height: 'col-sm-12',
		default: null,
		maxChars: 8,
		autoComplete: 'new-off',
		disabled: false,
		comboData: '',
		dependsOn: {
			id: '',
			values: [
				{
					idValue: '',
					disabled: false
				}
			]
		}
	},
	{
		id: 'valnum2',
		type: 'text',
		labelWidth: 'col-sm-2',
		width: 'col-sm-2',
		height: 'col-sm-12',
		default: null,
		maxChars: 8,
		autoComplete: 'new-off',
		disabled: false,
		comboData: '',
		dependsOn: {
			id: '',
			values: [
				{
					idValue: '',
					disabled: false
				}
			]
		}
	},
	{
		id: 'observ1',
		type: 'text',
		labelWidth: 'col-sm-2',
		width: 'col-sm-8',
		height: 'col-sm-12',
		default: null,
		maxChars: 100,
		autoComplete: 'new-off',
		disabled: false,
		comboData: '',
		dependsOn: {
			id: '',
			values: [
				{
					idValue: '',
					disabled: false
				}
			]
		}
	},
	{
		id: 'observ2',
		type: 'text',
		labelWidth: 'col-sm-2',
		width: 'col-sm-8',
		height: 'col-sm-12',
		default: null,
		maxChars: 100,
		autoComplete: 'new-off',
		disabled: false,
		comboData: 'voucherFields',
		dependsOn: {
			id: '',
			values: [
				{
					idValue: '',
					disabled: false
				}
			]
		}
	},
	{
		id: 'fecha1',
		type: 'date',
		labelWidth: 'col-sm-2',
		width: 'col-sm-2',
		height: 'col-sm-12',
		default: null,
		maxChars: 8,
		autoComplete: 'new-off',
		disabled: false,
		comboData: '',
		dependsOn: {
			id: '',
			values: [
				{
					idValue: '',
					disabled: false
				}
			]
		}
	},
	{
		id: 'fecha2',
		type: 'date',
		labelWidth: 'col-sm-2',
		width: 'col-sm-2',
		height: 'col-sm-12',
		default: null,
		maxChars: 8,
		autoComplete: 'new-off',
		disabled: false,
		comboData: '',
		dependsOn: {
			id: '',
			values: [
				{
					idValue: '',
					disabled: false
				}
			]
		}
	},
	{
		id: 'flag1',
		type: 'check',
		labelWidth: 'col-sm-2',
		width: 'col-sm-1',
		height: 'col-sm-12',
		default: null,
		maxChars: 1,
		autoComplete: 'new-off',
		disabled: false,
		comboData: '',
		dependsOn: {
			id: '',
			values: [
				{
					idValue: '',
					disabled: false
				}
			]
		}
	}
]
